import React, { useState } from "react";
import { sendDTMF } from "../../../base/callService/callService";
import { URInput } from "../../../shared/widgets/input";
import styles from "./scss/dialpadmainnumber.module.scss";

type DialKeypadState = {
  textVal: string
}
export default function DialKeypad() {
  const [getKeyPadText, setKeyPadText] = useState<DialKeypadState>
  ({ textVal: '' });
  
  const keyPressEvent = (key: string) => {
    setKeyPadText({ ...getKeyPadText, textVal: getKeyPadText.textVal + key });
    sendDTMF(key);
  };

  const textBoxOnchange = (keyPress: any) => {
    setKeyPadText({ ...getKeyPadText, textVal: keyPress.target.value });
  };

  return (
    <>
      <URInput name="" className={`${styles.dialnumbers} ${styles.extranumbers}`}
        value={getKeyPadText.textVal} maxLength={17}
        onChange={textBoxOnchange}/>
      <div className={styles.dialscreens}>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('1')}>
          <div className={styles.chatDialPadNumber}>1</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('2')}>
          <div className={styles.chatDialPadNumber}>2</div>
          <div className={styles.chatDialPadAlpha}>ABC</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('3')}>
          <div className={styles.chatDialPadNumber}>3</div>
          <div className={styles.chatDialPadAlpha}>DEF</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('4')}>
          <div className={styles.chatDialPadNumber}>4</div>
          <div className={styles.chatDialPadAlpha}>GHI</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('5')}>
          <div className={styles.chatDialPadNumber}>5</div>
          <div className={styles.chatDialPadAlpha}>JKL</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('6')}>
          <div className={styles.chatDialPadNumber}>6</div>
          <div className={styles.chatDialPadAlpha}>MNO</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('7')}>
          <div className={styles.chatDialPadNumber}>7</div>
          <div className={styles.chatDialPadAlpha}>PQRS</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('8')}>
          <div className={styles.chatDialPadNumber}>8</div>
          <div className={styles.chatDialPadAlpha}>TUV</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('9')}>
          <div className={styles.chatDialPadNumber}>9</div>
          <div className={styles.chatDialPadAlpha}>WXYZ</div>
        </div>
        <div className={`${styles.chatDialPadInner} ${styles.specials}`} onClick={ () => keyPressEvent('*')}>
          <div className={styles.chatDialPadNumber}>*</div>
          <div className={styles.chatDialPadChar}>,</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('0')}>
          <div className={styles.chatDialPadNumber}>0</div>
          <div className={styles.chatDialPadChar}>+</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('#')}>
          <div className={styles.chatDialPadNumber}>#</div>
        </div>
      </div>
    </>
  );
};

